// Committed (unlike most "environment" files) because the Docker build needs
// it present to compile the Angular app at all — see docker/README.md.
// apiUrl is relative rather than a hardcoded domain since this SPA and its
// API are always served from the same origin (Laravel serves both, see
// resources/views/index.blade.php), so it works unchanged across
// na2kolela.diadraw.vip, na2kolela.bg, or any other domain this ends up on.
// siteKey (reCAPTCHA) is a public, client-side key, not a secret.
export const environment = { siteKey: '6LeGEhIrAAAAACJPLOSgFEQgbKNi0w01rz6ga3c6', apiUrl: '/api' };
